'use strict';

const _ = require('lodash');

const AnnotationDialogController = function ($scope, $rootScope, AnnotationStore) {

  const vm = this;

  vm.showDialog = false;
  vm.annotation = null;

  $scope.$on('dialog:annotation:promptDelete', (ev, data) => {

    vm.annotation = _.find(AnnotationStore.get('available'), 'id', data.id);
    vm.view = 'delete';
    vm.actionLabel = 'Confirm Delete';
    vm.annotationName = vm.annotation.name;
    vm.showDialog = true;
  });

  $scope.$on('dialog:annotation:promptCancelEdit', () => {

    vm.view = 'cancelEdit';
    vm.actionLabel = 'Confirm Discard Changes';
    vm.annotationName = AnnotationStore.get('active').name;
    vm.showDialog = true;
  });

  $scope.$on('dialog:annotation:infoEmptyAnnotation', () => {

    vm.view = 'infoEmpty';
    vm.actionLabel = 'Empty layers';
    vm.showDialog = true;
  });

  $scope.$on('dialog:annotation:permissionsError', () => {

    vm.view = 'permissionsError';
    vm.error = AnnotationStore.get('error').friendlyMessage;
    vm.actionLabel = AnnotationStore.get('error').message;
    vm.showDialog = true;
  });

  vm.closeModal = () => {

    vm.showDialog = false;
  };

  vm.perform = () => {

    vm.closeModal();
    if (vm.view === 'delete' && vm.annotation) {
      $rootScope.$broadcast('dialog:annotation:confirmDelete', vm.annotation);
    }
    else if (vm.view === 'cancelEdit') {
      $rootScope.$broadcast('dialog:annotation:confirmCancelEdit');
    }
    vm.annotation = null;
  };

  vm.formatAnnotationName = () => {

    if (vm.annotationName) {
      return 'the annotation "' + vm.annotationName + '"';
    }
    else {
      return 'the unnamed annotation';
    }
  };

};

AnnotationDialogController.$inject = ['$scope', '$rootScope', 'AnnotationStore'];
module.exports = AnnotationDialogController;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/annotations/dialog/AnnotationDialogController.js